module.exports = __webpack_public_path__ + "static/media/meat.492a34ea.svg";